import type { EditorPlugin } from '../../types';
import { getDecorate } from './decorate';
import { InsertionMarkProbe } from './components/InsertionMarkProbe';
import { INSERTION_MARK_ID } from './types';

/**
 * `renderLeaf` cannot tell a property that came from the document from one that came from
 * a decoration — both arrive as `leaf.insertionMarkId` — so gating on the leaf is enough,
 * and the probe stays unaware of how it got there.
 *
 * Hand-written rather than the shared `getRenderLeaf` helper because the probe renders no
 * wrapper element: it reports and returns its children untouched, so there is nothing to
 * spread `attributes` onto.
 *
 * Inert until an insertion registers an anchor ref.
 */
export function InsertionMarkPlugin(): EditorPlugin {
  return {
    pluginID: INSERTION_MARK_ID,
    decorate: getDecorate(),
    renderLeaf: ({ children, leaf }) => {
      const insertionId = leaf.insertionMarkId;
      if (insertionId == null) return children;

      return <InsertionMarkProbe insertionId={insertionId}>{children}</InsertionMarkProbe>;
    },
  };
}
